import React from "react";

/**
 * Minimal saved-search / filtered list illustration.
 * Brand palette: primary purple + lavender wash (inspired by undraw simplicity).
 * https://undraw.co — composition reference only; artwork is original.
 */
export default function SavedSearchIllustration({ size = 168 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 168 168"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Saved search illustration"
    >
      <circle cx="84" cy="84" r="78" fill="#F6F4FF" />
      <rect
        x="44"
        y="42"
        width="80"
        height="96"
        rx="10"
        fill="#FFFFFF"
        stroke="#4A2CF5"
        strokeWidth="2"
      />
      <rect x="56" y="58" width="36" height="8" rx="4" fill="#4A2CF5" opacity="0.9" />
      <rect x="56" y="74" width="52" height="6" rx="3" fill="#775EFF" opacity="0.35" />
      <rect x="56" y="88" width="44" height="6" rx="3" fill="#775EFF" opacity="0.28" />
      <rect x="56" y="102" width="48" height="6" rx="3" fill="#775EFF" opacity="0.28" />
      <rect x="56" y="116" width="28" height="6" rx="3" fill="#775EFF" opacity="0.2" />
      <path
        d="M108 40v28l-8-5.5-8 5.5V40h16z"
        fill="#4A2CF5"
      />
      <circle cx="36" cy="56" r="3.5" fill="#775EFF" opacity="0.4" />
      <circle cx="134" cy="120" r="4" fill="#4A2CF5" opacity="0.3" />
    </svg>
  );
}
